import {defineStore} from "pinia";

export const useDebtStore = defineStore('debt', {
    state: () => ({
        debt: {},
        debts: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setDebt(debt) {
            this.debt = debt
        },
        setDebts(debts) {
            this.debts = debts
        },
        addDebt(debt) {
            this.debts.unshift(debt)
        },
        updateDebt(debt) {
            let index = this.debts.findIndex(cl => cl.id === debt.id)
            this.debts.splice(index, 1, debt)
        },
        deleteDebt(debt) {
            let index = this.debts.findIndex(cl => cl.id === debt.id)
            this.debts.splice(index, 1)
        },
    },
});